import { render, staticRenderFns } from "./ArticleData.vue?vue&type=template&id=5b6d1b8b&"
import script from "./ArticleData.vue?vue&type=script&lang=js&"
export * from "./ArticleData.vue?vue&type=script&lang=js&"
import style0 from "./ArticleData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports